import {
    CREATE_PIM_DETAILS_FAILURE,
    CREATE_PIM_DETAILS_REQUEST,
    CREATE_PIM_DETAILS_SUCCESS,
    CREATE_USER_FORM_PIM_DETAILS,
    DELETE_PIM_DETAILS_FAILURE,
    DELETE_PIM_DETAILS_REQUEST,
    DELETE_PIM_DETAILS_SUCCESS,
    FETCH_SINGLE_PIM_DETAILS_FAILURE,
    FETCH_SINGLE_PIM_DETAILS_REQUEST,
    FETCH_SINGLE_PIM_DETAILS_SUCCESS,
    FETCH_PIM_DETAILS_FAILURE,
    FETCH_PIM_DETAILS_REQUEST,
    FETCH_PIM_DETAILS_SUCCESS,
    PIM_DETAILS_USERFORM_RESET,
    UPDATE_PIM_DETAILS_FAILURE,
    UPDATE_PIM_DETAILS_REQUEST,
    UPDATE_PIM_DETAILS_SUCCESS,
    FETCH_PIM_DETAILS_INWARD_NO_REQUEST,
    FETCH_PIM_DETAILS_INWARD_NO_SUCCESS,
    FETCH_PIM_DETAILS_INWARD_NO_FAILURE
} from './pimDetails.actionsType';

export const PIM_DETAILS = 'pimDetails';

let initialState = {
    loading: false,
    pimDetailsById: [],
    pimDetailInwardNo: [],
    userform: {},
    selectedTeamDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let pimDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_PIM_DETAILS_REQUEST:
        case FETCH_PIM_DETAILS_INWARD_NO_REQUEST:
        case CREATE_PIM_DETAILS_REQUEST:
        case FETCH_SINGLE_PIM_DETAILS_REQUEST:
        case UPDATE_PIM_DETAILS_REQUEST:
        case DELETE_PIM_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PIM_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                pimDetailsById: updatePayload
            };
        case FETCH_PIM_DETAILS_INWARD_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                pimDetailInwardNo: updatePayload
            };
        case CREATE_PIM_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_PIM_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeamDetails: updatePayload,
                userform: updatePayload
            };
        case UPDATE_PIM_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedTeamDetails: {},
                userform: {}
            };
        case DELETE_PIM_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedTeamDetails: {}
            };
        case FETCH_PIM_DETAILS_FAILURE:
        case FETCH_PIM_DETAILS_INWARD_NO_FAILURE:
        case FETCH_SINGLE_PIM_DETAILS_FAILURE:
        case CREATE_PIM_DETAILS_FAILURE:
        case UPDATE_PIM_DETAILS_FAILURE:
        case DELETE_PIM_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_PIM_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case PIM_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {},
                selectedTeamDetails: {}
            };
        default:
            return state;
    }
};
